export const dealCreatedBySelectValues: { id: number; name: string }[] = [
  { id: 0, name: "global.createdBy.all" },
  { id: 1, name: "global.createdBy.api" },
  { id: 2, name: "global.createdBy.dashboard" },
  { id: 3, name: "global.createdBy.unknown" }
];

export const statusDealOptions: { id: number; name: string }[] = [
  { id: 0, name: "Status" },
  { id: 1, name: "Live" },
  { id: 2, name: "Offline" }
];

export const categoriesDealOptions: { id: number; name: string }[] = [{ id: 0, name: "Categorieën" }];

export const brandsDealOptions: { id: number; name: string }[] = [{ id: 0, name: "Merken" }];

export enum BulkLabelMode {
  Unchanged = 0,
  Set = 1,
  Clear = 2
}

export const bulkLabelModeOptions: { id: BulkLabelMode; name: string }[] = [
  { id: BulkLabelMode.Unchanged, name: "dealOverviewOptionsBarComponent.label.unchanged" },
  { id: BulkLabelMode.Set, name: "dealOverviewOptionsBarComponent.label.set" },
  { id: BulkLabelMode.Clear, name: "dealOverviewOptionsBarComponent.label.clear" }
];

export interface IDealEditOptions {
  /** 1 live, 2 offline; 0 or null leaves the status of the deals as it is. */
  status: number | null;
  /** The label filter id to set, null to remove the label, undefined to leave it as it is. */
  featuredFilterId?: number | null;
}
